import React from "react";
import StatCard from "../Components/StatCard";
import SectionLabel from "../Components/SectionLabel";
import StatGrid from "../Components/statGrid";

/**
 * TasksTab
 *
 * Props:
 *   data — { completed3Task, userTaskOpen }
 */
const TasksTab = ({ data = {} }) => {
  return (
    <>
      <SectionLabel>Task overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Completed tasks"
          value={data?.completed3Task}
          sub="Users who completed 3 tasks"
          accent="green"
        />
        <StatCard
          label="Open tasks"
          value={data?.userTaskOpen}
          sub="Users with tasks in progress"
          accent="amber"
        />
      </StatGrid>
    </>
  );
};

export default TasksTab;
